const backorderHover = "#ffb700";
const backorderNormal = "#efd016";

const preBackorderHover = "#ffb700";
const preBackorderNormal = "#feffe4";

const textColor = "#3A3541CC";

const buttonBase = {
    borderRadius: 20,
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 600,
    padding: 1,
    color: textColor,
    width: { md: "auto", sm: "100%" },
};

export const buttonStyles = {
    ...buttonBase,
    backgroundColor: backorderNormal,
    border: `1px solid ${backorderNormal}`,
    boxShadow: "0 4px 12px #00000026",
    "&.MuiButton-root:hover": {
        color: textColor,
        backgroundColor: backorderHover,
        border: `1px solid ${backorderHover}`,
    },
};

export const secondaryButtonStyles = {
    ...buttonBase,
    backgroundColor: preBackorderNormal,
    border: `1px solid ${preBackorderHover}`,
    "&.MuiButton-root:hover": {
        color: textColor,
        backgroundColor: preBackorderNormal,
        border: `2px solid ${preBackorderHover}`,
    },
};

export const bidButtonStyles = {
    color: "#3A3541CC",
    backgroundColor: backorderNormal,
    borderRadius: 20,
    border: "none",
    textTransform: "none",
    fontSize: "14px",
    px: 2,
    py: 1,
    "&.MuiButton-root:hover": {
        color: "#3A3541CC",
        backgroundColor: backorderHover,
        border: "none",
    },
    width: "100%",
    fontWeight: 600,
};
